module.exports = "::ng-deep icecheckbox > mat-form-field .mat-form-field-wrapper {\n  padding-bottom: 0 !important; }\n"